<template>
  <div>
    <wait-detail-head :data="headData" @refresh="fetch"></wait-detail-head>
    <collention-details :data="payList"></collention-details>
    <wait-detail-list :data="orderList"></wait-detail-list>
  </div>
</template>

<script>
import WaitDetailHead from './component/wait-detail-head'
import CollentionDetails from './component/collention-details'
import WaitDetailList from './component/wait-detail-list'

export default {
  name: 'SettlementWaitDetail',
  components: { WaitDetailHead, CollentionDetails, WaitDetailList },
  data() {
    return {
      payList: [],
      orderList: [],
      headData: {
        buyerId: '',
        bizOrderId: '',
        accountPayId: '',
        accountPayStatus: '',
        certUploadFlag: '',
        allowPayStatus: '',
        buyerOrgName: '',
        orderStatus: '',
        buyerNick: '',
        buyerOrgId: '',
        orderGmtCreated: '',
        orderAmount: '',
        paidAmount: '',
        settledAmount: '',
        amount: '',
        amountDirection: ''
      }
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      const request = { bizOrderId: this.$route.params.id }
      const { success, data } = await this.$post('accountOrder.seller.queryAccountOrderInfo', {
        request
      })
      if (success && data) {
        const { accountOrderDetailPayVOList, settleOrderItemVOList } = data[0]
        this.payList = accountOrderDetailPayVOList
        Object.keys(this.headData).forEach(key => {
          this.headData[key] = data[0][key]
        })
        //根据结算单编号分组
        const filterGroup = {}
        settleOrderItemVOList.forEach(ele => {
          const { settleOrderNo } = ele
          if (filterGroup[settleOrderNo]) {
            filterGroup[settleOrderNo].list.push(ele)
          } else {
            const list = []
            list.push(ele)
            filterGroup[settleOrderNo] = {
              $totalQuantity: 0,
              $totalWeight: 0,
              $totalAmount: 0,
              list,
              ...ele
            }
          }
        })
        const groupArray = []
        Object.keys(filterGroup).forEach(key => {
          groupArray.push(filterGroup[key])
        })
        //
        this.orderList = groupArray
      }
    }
  }
}
</script>
